/* unplugin-vue-components disabled */import script from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=1b8403e0&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8403e0"]])

export default __exports__